import cx from 'classnames'
import React, { ChangeEventHandler } from 'react'

import styles from './checkbox.module.scss'

export type TProps = {
  label?: React.ReactNode
  invalid?: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
} & React.InputHTMLAttributes<HTMLInputElement>

const Checkmark = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 13h1l7-11-1-1h-1L5 11 2 7 1 6 0 7v1l4 5h1z"
      fill="currentColor"
    />
  </svg>
)

export const Checkbox = (props: TProps) => {
  const {
    label,
    checked,
    disabled,
    invalid,
    onChange,
    className,
    id,
    ...otherProps
  } = props

  return (
    <label htmlFor={id} className={styles['checkbox-wrapper']}>
      <input
        type="checkbox"
        checked={checked}
        className={styles.hiddenCheckbox}
        disabled={disabled}
        onChange={onChange}
        id={id}
        {...otherProps}
      />

      <div
        className={cx(styles.checkbox, className, {
          [styles.invalid]: invalid,
        })}
      >
        {checked && <Checkmark />}
      </div>
      {label != null && <span className={styles.label}>{label}</span>}
    </label>
  )
}
